import styled from 'styled-components';

export const ActionButtonLayout = styled.button`
  height: 44px;
  padding: 10px 16px;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  i {
    font-size: 20px;
    color: #484848;
    display: flex;
  }

  span {
    color: #343a40;
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
  }

  &:hover {
    background: #f7fafc;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:disabled.loading {
    cursor: wait;
  }
`;
